import { computed, ref, readonly } from 'vue'
import { clone } from 'ramda'

import { useCore } from '@/composables/core'
import { useEppo } from '@/composables/eppo/index.js'
import { ENDPOINTS, FEATURE_FLAGS } from '@/lib/consts.js'

const cachedAgreements = ref(null)

export function useGdprAgreements () {
  const { apiCall, store } = useCore()
  const eppo = useEppo()

  const business = computed(() => store.state.business?.business)

  const saveAgreements = (agreements) => {
    const filteredAgreements = agreements.filter(a => !a.information)

    return apiCall({
      method: 'PUT',
      url: ENDPOINTS.BUSINESS_AGREEMENTS,
      urlParams: {
        businessId: business.value?.id,
      },
      data: {
        business_agreements: filteredAgreements,
      },
    })
  }

  const loadAgreements = async () => {
    if (cachedAgreements.value) return cachedAgreements.value

    const data = await apiCall({
      method: 'GET',
      url: ENDPOINTS.AGREEMENTS,
    })

    return data?.data?.business_agreements
  }

  const isGdprEnabled = computed(() =>
    store.state.routingConfig.config.gdpr
    && (!store.state.business?.business || store.state.business.business.is_gdpr_first_run)
  )

  const isUSMarketingConsentEnabled = computed(() =>
    eppo.ff(FEATURE_FLAGS.Feature_SMSMarketingConsentUS)
    && store.state.routingConfig.config.country?.code === 'us'
  )

  const cacheAgreements = (agreements) => {
    cachedAgreements.value = clone(agreements)
  }

  const clearCachedAgreements = () => {
    cachedAgreements.value = null
  }

  return {
    cacheAgreements,
    cachedAgreements: readonly(cachedAgreements),
    clearCachedAgreements,
    saveAgreements,
    loadAgreements,
    isGdprEnabled,
    isUSMarketingConsentEnabled,
  }
}
